<template>
	<v-bottom-sheet
		v-model="mostra"
		width="300"
		ref="dialogo"
		inset
	>
		<template v-slot:activator="{ on }">
			<v-badge
				color="yellow darken-4"
				bottom
				overlap
				v-model="temFiltro"
				style="height: 100%;"
			>
				<template v-slot:badge>
					<v-icon dark> mdi-check </v-icon>
				</template>
				<v-btn
					height="100%"
					v-on="on"
					dark
					outlined
				> Filtros </v-btn>
			</v-badge>
		</template>
		<v-list subheader>
			<v-card-title>Filtros</v-card-title>

			<v-list-item>
				<v-select
					label="Buscar em"
					v-model="filtro.buscarEm"
					multiple
					:items="buscarEmOptions"
					item-text="descricao"
					item-value="valor"
				>
					<template v-slot:selection="{ item, index }">
						<v-chip v-if="index < 2">
							<span>{{ item.descricao }}</span>
						</v-chip>
						<span
							v-if="filtro.buscarEm && index === 2"
							class="grey--text text-caption"
						>
							(+{{ filtro.buscarEm.length - 2 }} outros)
						</span>
					</template>
				</v-select>
			</v-list-item>

			<v-list-item>
				<SeletorDeSituacaoDoMacon
					label="Situação do Maçon"
					multiple
					v-model="filtro.situacoes"
				/>
			</v-list-item>

			<v-list-item>
				<SeletorDeLojas
					label="Loja"
					v-model="filtro.loja"
					:return-object="true"
					clearable
				/>
			</v-list-item>

			<v-list-item>
				<v-list-item-content>
					<div class="text-caption font-weight-light">Mostrar</div>
					<div>
						<v-btn-toggle
							v-model="filtro.recentes"
							mandatory
							color="primary"
							dense
							class="mb-2"
						>
							<v-btn class="flex-grow-1" :value="false">
								Todos
							</v-btn>
							<v-btn class="flex-grow-1" :value="true">
								Novos
							</v-btn>
						</v-btn-toggle>
						<v-tooltip bottom max-width="240">
							<template #activator="{ on, attrs }">
								<v-icon v-on="on" v-bind="attrs" icon class="ml-2">mdi-information-outline</v-icon>
							</template>
							Somente novos serviços serão exibidos
						</v-tooltip>
					</div>
				</v-list-item-content>
			</v-list-item>

			<v-card-actions>
				<v-btn
					text
					:color="!temFiltro ? 'grey' : undefined"
					@click="limpar"
				> Limpar </v-btn>
				<v-spacer />
				<v-btn
					text
					color="primary"
					@click="() => {mostra = false; $emit('confirma')}"
				>
					OK
				</v-btn>
			</v-card-actions>
		</v-list>
	</v-bottom-sheet>
</template>

<script lang="ts">
export default {
	model: {
		prop: 'filtro',
	},
}
</script>

<script setup lang="ts">
import { computed, PropType, ref, watch } from 'vue'
import SeletorDeSituacaoDoMacon from '@/components/SeletorDeSituacaoDoMacon.vue'
import SeletorDeLojas from '@/components/SeletorDeLojas.vue'
import { CamposDoFiltroDeBusca, obterFiltroDefault, OPCOES_DE_BUSCAR_EM } from '@/shareds/sharedBusca'

const props = defineProps({
	filtro: {
		type: Object as PropType<CamposDoFiltroDeBusca>,
		required: true,
	},
})

const emit = defineEmits<{
	(e: 'input', filtro: CamposDoFiltroDeBusca): void
	(e: 'confirma'): void
}>()

const mostra = ref(false)

watch(() => props.filtro, (filtro) => {
	emit('input', filtro)
})

function limpar() {
	emit('input', obterFiltroDefault())
	emit('confirma')
}

const temFiltro = computed(() => JSON.stringify(obterFiltroDefault()) !== JSON.stringify(props.filtro))

const buscarEmOptions = OPCOES_DE_BUSCAR_EM
</script>
